<template>
  <el-container>
    <el-header>
			<Header></Header>
		</el-header>
    <el-main :class="{'main-content': bgColor }">
      <div class="content-box">
			  <router-view/>
      </div>
      <div class="footer-box">
        <Footer></Footer>
      </div>
		</el-main>
  </el-container>
</template>

<script>
import Header from '@/components/Header'
import Footer from './components/Footer/index';
export default {
	name: "layout",
	components:{
    Header,
    Footer
	},
  data() {
    return {
      bgColor: this.$store.state.display.isDisplay || false
    };
  },
  watch: {
    '$store.state.display.isDisplay'(newValue){
      this.bgColor = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-container{
  height: 100%;
  overflow: hidden;
  .el-header{
		height: 70px!important;
		padding: 0;
  }
  
  // .el-aside {
  //   background-color: #D3DCE6;
  //   color: #333;
  //   text-align: center;
  //   line-height: 200px;
  // }
  
  .el-main {
    padding: 0;
    color: #333;
		text-align: center;
    min-height: calc(100% - 70px);
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 100% auto;
    &.main-content{
      background-image: url('~@/assets/images/bg.svg');
      background-color: #f7f7fc;
    }
    .content-box{
      min-height: calc(100% - 90px);
      padding: 20px 0;
      box-sizing: border-box;
    }
    .footer-box{
      margin-bottom: 46px;
    }
  }
}
</style>